import React from 'react';
import { useSnackbar } from 'notistack';

let useSnackbarRef;
export const SnackbarUtilsConfigurator = () => {
  useSnackbarRef = useSnackbar();
  return null;
};

export default {
  toast(message, options = {}) {
    useSnackbarRef.enqueueSnackbar(message, options);
  }
};
